import React from "react"
import { motion } from "framer-motion"

export default function AboutHero() {
  return (
    <section className="relative h-[70vh] min-h-[520px] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="/images/about-hero.jpg"
          alt="Spa bien-être à propos de nous intérieur luxueux"
          loading="eager"
          className="w-full h-full object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            {/* Subtitle */}
            <motion.span
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="inline-block text-[#d6b57b] uppercase tracking-[5px] text-sm md:text-base mb-6"
            >
              A Propos de Nous
            </motion.span>

            {/* Title */}
            <motion.h1
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9 }}
              className="text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-tight"
            >
             Une Expérience de Spa Luxe
              <span className="block text-[#d6b57b]">
                Conçu pour vous
              </span>
            </motion.h1>

            {/* Description */}
            <motion.p
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.1 }}
              className="mt-8 text-gray-200 text-base md:text-lg leading-relaxed max-w-2xl"
            >
              Nous nous engageons à vous offrir des soins de bien-être, de relaxation et de beauté haut de gamme dans un environnement calme et luxueux, adapté à vos besoins.
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  )
}